window.addEventListener('DOMContentLoaded', (event) => {
	const helpful = document.querySelector('.helpful');

	if (helpful) {
		let likes = {
				likeState: 'like',
				total: 0,
				now: 0,
				sent: 0,
				nowDisplayElem: document.querySelector('#likes_dislikes'),
				totalDisplayElem: document.querySelector('#likes_total'),
			},
			dislikes = {
				likeState: 'dislike',
				total: 0,
				now: 0,
				sent: 0,
				nowDisplayElem: document.querySelector('#likes_dislikes'),
				totalDisplayElem: document.querySelector('#dislikes_total'),
			};
		let acflikes = document.querySelector('#likes_dislikes').innerHTML;
		const postId = document.querySelector('[data-likes]').dataset.id;
		// create debounce callback
		const dbCallback = function (totals) {
			// The debounced callback, when it fires after `x` seconds will"
			let { now, sent, total, likeState, ...theRest } = totals;
			// - get the amount to send by taking the `now` value and subtracting the `sent` value so that we know how many to send "this time"

			const data = new FormData();
			const nonce = document.getElementById('update_likes_nonce');

			data.append('action', 'update_likes');
			data.append('fn', likeState === 'like' ? 'likes' : 'dislikes');
			data.append('nonce', nonce.value);
			data.append('post_id', postId);
			data.append('count', now);

			const xmlhttp = new XMLHttpRequest();
			xmlhttp.onreadystatechange = function () {
				if (xmlhttp.readyState == XMLHttpRequest.DONE) {
					if (xmlhttp.status == 200) {
						const resp = JSON.parse(this.response);
					}
				}
			};

			xmlhttp.open('POST', app.ajax_url, true);
			xmlhttp.send(data);
			// Assume 200 response and update total
			total += now;
			// - add `now` to the `sent` value
			sent += now;
			// - clear out now
			now = 0;
			totals.totalDisplayElem.value = total;
			if (likeState === 'like') {
				likes = { now, sent, total, likeState, ...theRest };
			} else {
				dislikes = { now, sent, total, likeState, ...theRest };
			}
		};
		const debounces = {
			like: _.debounce(dbCallback, 2000),
			dislike: _.debounce(dbCallback, 2000),
		};
		// add click listeners to the buttons
		const buttons = document.querySelectorAll('.helpful__icon');
		buttons.forEach((btn) => {
			btn.addEventListener('click', function (event) {
				this.classList.add('active');
				// in each click we will:
				// - get the delta to change
				const thisBtn = event.target;
				const delta = Number(thisBtn.dataset.delta);
				// - update the `now` value for the like or dislike
				const isLike = delta > 0;
				const totals = isLike ? { ...likes } : { ...dislikes };
				totals.now += 1;
				// - display the `now` on the screen
				totals.nowDisplayElem.innerHTML = totals.now + totals.sent;
				// - trigger another trip to the debounce call
				if (isLike) {
					debounces.like(totals);
					totals.nowDisplayElem.innerHTML = ++acflikes;
				} else {
					debounces.dislike(totals);
					totals.nowDisplayElem.innerHTML = --acflikes;
				}

				// Update the global values with these
				if (isLike) {
					likes = { ...totals };
				} else {
					dislikes = { ...totals };
				}
			});
		});
	}
});
